import axiosInstance from './axiosInstance';
import { store } from '../hooks/context/StoreContext';

export const verificarTokenViaAxios = async () => {
  try {
    
    await axiosInstance.get('/verificacao/verificar-token', {
        headers: { 'X-Skip-Interceptor': 'true' }
      });

    const token = localStorage.getItem('token');
    if (token) {
      try {
        await axiosInstance.post('/verificacao/verificar-token', {
          TOKEN: token
        }, {
          headers: { 'X-Skip-Interceptor': 'true' }
        });
      } catch (tableError) {
        if (tableError.response?.status === 401) {
          throw tableError;
        }
      }
    }

    return true;
  } catch (error) {
    if (error.response?.status === 401) {
      const currentPath = window.location.pathname;

      if (currentPath !== '/login') {
        store.setModal(prev => ({
          ...prev,
          openModalConfirm: true,
          identificadorModalConfirm: 'token-expirado',
          tituloModalConfirm: 'Sessão expirada',
          subtituloModalConfirm: 'Sua sessão expirou ou o token é inválido. Faça login novamente.',
          textoModalConfirm: '',
        }));
      }
    }

    return false;
  }
};
